import { SubHeader } from '../../components/SubHeader';
import { Actions } from './Actions';

const displayContent = {
  pageTitle: 'Subscriptions',
};

export const Header = () => <SubHeader actions={<Actions />}>{displayContent.pageTitle}</SubHeader>;
